import { render, staticRenderFns } from "./supportBank.vue?vue&type=template&id=00e98894"
import script from "./supportBank.vue?vue&type=script&lang=js"
export * from "./supportBank.vue?vue&type=script&lang=js"
import style0 from "./supportBank.vue?vue&type=style&index=0&id=00e98894&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports